module.exports = process.env.REACT_APP_NODE_ENV === 'production' ? require('./configureStore.prod') : require('./configureStore.dev')
